import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import React, { useState, useEffect } from 'react';
import Chat from '../Chat';
import List from '@material-ui/core/List';
import PersonIcon from '@material-ui/icons/Person';
import GroupIcon from '@material-ui/icons/Group';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Divider from '@material-ui/core/Divider';
import axios from 'axios';
import AppBar from '@material-ui/core/AppBar';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Box from '@material-ui/core/Box';
import { Container, IconButton } from '@material-ui/core';
import useStyles from './styles';
import { EMOJIS } from './../../utils';
import Menu from '@material-ui/core/Menu';
import Fade from '@material-ui/core/Fade';
import MenuItem from '@material-ui/core/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
// import { GET_PARTICIPANTS_LIST } from 'store/ParticipantsList/participantsListAction';
import { useRole } from '../../context/RoleContext';
import io from 'socket.io-client';
import { RowMenu } from './RowMenu';
import Tooltip from '@material-ui/core/Tooltip';
import PanToolIcon from '@material-ui/icons/PanTool';
import { CHANGE_SUBSCRIBER_ROLE } from 'store/ParticipantsList/participantsListAction';
import useSignal from 'hooks/useSignal';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Container style={{ padding: '0px' }}>
          <Box>{children}</Box>
        </Container>
      )}
    </div>
  );
}

const SideMenu = ({
  participants,
  room,
  localParticipant,
  listOfMessages,
  isOpen,
  pid,
  userid,
}) => {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [listData, setListData] = useState([]);
  const [data, setData] = useState({});
  const [speakers, setSpeakers] = useState([]);
  // const [list, setList] = useState({});
  const { sendSignal } = useSignal({ room });
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const [roleChangeId, setRoleChangeId] = useState('');
  const state = useSelector((state) => state.participantsListReducer);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // const fetchParticipantList = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_API_URL_NET}/Play/GetParticipationList?vId=${pid}`
  //     );
  //     dispatch({
  //       type: GET_PARTICIPANTS_LIST,
  //       payload: response.data,
  //     });
  //   } catch (error) {
  //     console.error('Error fetching data:', error);
  //   }
  // };
  // console.log('data from state', state.participantsList);
  useEffect(() => {
    const userData = sessionStorage.getItem('userData');
    if (userData !== 'undefined') {
      const data = JSON.parse(userData);
      setData(data);
      console.log('sessionData', data);
    }
    // const interval = setInterval(() => {
    //   fetchParticipantList();
    // }, 25000);
    //return () => clearInterval(interval);
  }, []);

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleRoleChange = (UserId, role, paramUserId) => {
    console.log('handleRoleChange', UserId, role);
    // await UpdateUserRole(UserId);

    if (role === 'Speaker') {
      setRoleChangeId(paramUserId);
      setSpeakers((prevSpeakers) => [...prevSpeakers, paramUserId]);
    } else {
      setRoleChangeId('');
      setSpeakers((prevSpeakers) =>
        prevSpeakers.filter((id) => id !== paramUserId)
      );
    }

    const roleChangeData = { UserId, role, paramUserId };
    // dispatch({
    //   type: CHANGE_SUBSCRIBER_ROLE,
    //   payload: roleChangeData,
    // });
    sendSignal({
      type: 'roleChange',
      data: roleChangeData,
    });
    handleClose();
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const UpdateUserRole = async (UserId) => {
    try {
      const participant = await axios.get(
        `${process.env.REACT_APP_API_URL_NET}/Play/GetParticipationbyId?vId=${pid}&userid=${UserId}`
      );
      if (participant.data) {
        let payload = {
          ...participant.data,
          LeaveTime: null,
          Role: participant.data.Role == 'viewer' ? 'guest' : 'viewer',
        };
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL_NET}/Play/UpdateParticipantsList`,
          payload
        );
        // setApiData(response.data);
        // console.log("res", response);

        // // Trigger a custom event to notify the .NET CSHTML page
        // const event = new CustomEvent('iframeDataChanged', { detail: response.data });
        // window.dispatchEvent(event);

        if (response.data) {
          const socket = io(`${process.env.REACT_APP_API_URL}`);
          socket.emit('roleUpdatedByAdmin', payload.Role);
        }
        // fetchParticipantList();
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // console.log('need', room && Object.entries(room.participants));

  // useEffect(() => {
  //   if (room) {
  //     room &&
  //       Object.entries(room?.participants).map((item) => {
  //         if (item[1].isMe === false) {
  //           console.log(item[1].connectionData);
  //         }
  //       });
  //   }
  // }, [room, signalflag, joinedFlag]);

  console.log(state.participantsList);
  return (
    <div className={`${classes.chatMain} ${isOpen && classes.chatMainOpen}`}>
      <AppBar position='static'>
        <div className={classes.chatTabWrapper}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label='More option tabs'
          >
            <Tab label='Private Chat' {...a11yProps(0)} />
            <Tab label='List of Participants' {...a11yProps(1)} />
          </Tabs>
        </div>
      </AppBar>

      <TabPanel value={value} index={0}>
        <Chat room={room} listOfMessages={listOfMessages} />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <List>
          {state.participantsList && (
            //Adding +! as currently participants do not include self
            <>
              <ListItem key={'participants_counter'}>
                <ListItemIcon>
                  <GroupIcon variant='contained' color='primary' />
                </ListItemIcon>
                Participants ({state && state.participantsList?.length})
              </ListItem>
            </>
          )}

          {state &&
            state.participantsList?.map((item) => {
            return (
              <>
                <ListItem key={item.vonageParticipantId}>
                  <ListItemIcon>
                    <PersonIcon variant='contained' color='primary' />
                  </ListItemIcon>
                  <ListItemText primary={item.name} />
                  {item.handRaised === true && (
                    <Tooltip title='Raise Hand'>
                      <IconButton
                        aria-label='more'
                        aria-controls='long-menu'
                        aria-haspopup='true'
                      >
                        <PanToolIcon />
                      </IconButton>
                    </Tooltip>
                  )}
                  {speakers.includes(item.userId) && <h5>Speaker</h5>}
                  <>
                    <RowMenu data={item} handleRoleChange={handleRoleChange} />
                  </>
                </ListItem>
                <Divider />
              </>
            );
          })}
        </List>
      </TabPanel>
    </div>
  );
};

export default SideMenu;
